import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, of, throwError } from 'rxjs';
import { AuthenticationService } from '../authentication-service/authentication.service';
import { CommonAPIResponse } from 'src/app/classes/ApiModels';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService,private router: Router,private commonService:CommonService) {}
  specificEndpoints = ['/GetFormList','/AccountDept','/GetResponseDetailsByForm','/CreateForm','/EditForm','/AddQuestion','/EditQuestion','/SaveFormInstruction','/ChangeQuestionSequence']
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {    

      let token = this.authenticationService.getToken() 
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && this.specificEndpoints.some(endpoint => request.url.includes(endpoint))) {
          this.commonService.showCenterError("Token Expired","Unauthorized")
          this.router.navigate(['/sign-in']);
        }
        return throwError(error);
      }));
  }
}
